import { PERIODS_FOR_ZOG, GROWTH_RATE } from './ZoGConstants';
import { PERIOD } from './CommonConstants';

const { BOY_MOY, MOY_EOY, BOY_EOY, BOY, MOY } = PERIOD;

export const INDEX = {
    BENCHMARK_COL_SPAN_START_INDEX: 5,
    BENCHMARK_COL_SPAN_END_INDEX: 6,
    GROWTH_COL_SPAN_START_INDEX: 7,
    GROWTH_COL_SPAN_END_INDEX: 8,
    GOAL_COL_SPAN_START_INDEX: 9,
    GROWTH_ANALYSIS_COLUMN_COUNT: 10,
};

export const SECTION = {
    MET: 'Met',
    ACHIEVED: 'Achieved',
    GROWTH_SECTIONS: ['Needed', 'Achieved'],
    GOAL_SECTIONS: ['Set', 'Met'],
};

export const PERIODS_FOR_GROWTH_ANALYSIS = [
    ...PERIODS_FOR_ZOG,
    { key: BOY_EOY, title: 'Full Year' },
];

export const TITLE = {
    GROWTH_TITLE: 'Growth',
    BENCHMARK_SCORES_TITLE: 'Benchmark Scores',
    GOAL_TITLE: 'Goal',
};

export const GROWTH_RATE_LEVELS = [
    GROWTH_RATE.WELL_BELOW_AVERAGE,
    GROWTH_RATE.BELOW_AVERAGE,
    GROWTH_RATE.AVERAGE,
    GROWTH_RATE.ABOVE_AVERAGE,
    GROWTH_RATE.WELL_ABOVE_AVERAGE,
];

export const GROWTH_ANALYSIS_SORTABLE_COLUMNS = [0, 1, 2, 3];

export const ACHIEVED_RATE = {
    YEAR_GROWTH_RATE: 'yearAchievedGrowthRate',
    GROWTH_RATE: 'achievedGrowthRate',
};

export const ACHIEVED_RATE_LEVEL = {
    YEAR_GROWTH_RATE_LEVEL: 'yearAchievedGrowthRateLevel',
    GROWTH_RATE_LEVEL: 'achievedGrowthRateLevel',
};

export const getGrowthAnalysisPeriodByCurrentPeriod = currentPeriod => {
    switch (currentPeriod) {
        case BOY:
        case MOY:
            return BOY_MOY;
        default:
            return BOY_EOY;
    }
};
// TO DO Diff this method
export const getGrowthAnalysisPeriodBySelectedPeriod = currentPeriod => {
    switch (currentPeriod) {
        case BOY:
        case MOY:
            return BOY_MOY;
        default:
            return MOY_EOY;
    }
};
